import { useState } from 'react';
import { UserWaitlistButton, UserWaitlistWrapper, WaitlistModal } from './elements';
import { PathCreator, RoutePaths } from 'routing/constants';
import { UserWaitlistForm } from './waitlist-form';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { getProfileState } from 'models/profile/selectors';
import { useAppSelector } from 'utils/hooks';
import { getCourseSelector } from 'models/course/selectors';

export const UserWaitlist = () => {
  const [isModalOpened, setModalOpened] = useState(false);
  const currentProfile = useSelector(getProfileState);
  const course = useAppSelector(getCourseSelector);

  const showModal = () => {
    setModalOpened(true);
  };

  const handleCancel = () => {
    setModalOpened(false);
  };
  return (
    <UserWaitlistWrapper>
      <UserWaitlistButton hidden={isModalOpened || !course?.waitlistActive} onClick={showModal}>
        <PlayCircleOutlined />
        <div>
          <span>CAN'T FIND YOUR TEE TIME?</span>
          <span>ADD YOURSELF TO OUR WAITLIST!</span>
        </div>
      </UserWaitlistButton>

      <WaitlistModal
        title="Waitlist Settings"
        centered
        open={isModalOpened}
        footer={null}
        onCancel={handleCancel}
        destroyOnClose
      >
        {!currentProfile.sub ? (
          <div className="waitlist-unauthorized">
            <p>Receive notifications when tee times matching your preferences become available.</p>
            <p>
              <a href={PathCreator[RoutePaths.AUTH_LOGIN].getUrl()}>Sign in</a> to access this feature, or{' '}
              <a href={PathCreator[RoutePaths.AUTH_SIGNUP].getUrl()}>create an account</a> if you're new here.
            </p>
          </div>
        ) : (
          <UserWaitlistForm onSave={handleCancel} />
        )}
      </WaitlistModal>
    </UserWaitlistWrapper>
  );
};

